import { render } from "./ContactType.vue?vue&type=template&id=d11e8ba4"
import script from "./ContactType.vue?vue&type=script&lang=js"
export * from "./ContactType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__